import editor from "medium-editor";

const FontColorButton = editor.Extension.extend({
  name: "font-color",

  init() {
    //const callback = this.getEditorOption("fontColorCallback");
    const colorSamples = [
      "#ffffff",
      "#C0C0C0",
      "#808080",
      "#000000",

      "#fabebe",
      "#e6beff",
      "#f032e6",
      "#911eb4",

      "#ffe119",
      "#f58231",
      "#e6194B",
      "#800000",

      "#ffd8b1",
      "#aaffc3",
      "#3cb44b",
      "#808000",

      "#008080",
      "#46f0f0",
      "#4363d8",
      "#000075",
    ];
    this.button = this.document.createElement("button");
    this.button.classList.add("medium-editor-action");
    this.button.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.4199 14.5399C6.23365 14.7273 6.12911 14.9807 6.12911 15.2449C6.12911 15.5091 6.23365 15.7625 6.4199 15.9499C6.51286 16.0436 6.62346 16.118 6.74532 16.1688C6.86718 16.2196 6.99789 16.2457 7.1299 16.2457C7.26191 16.2457 7.39262 16.2196 7.51448 16.1688C7.63633 16.118 7.74694 16.0436 7.8399 15.9499C8.02615 15.7625 8.13069 15.5091 8.13069 15.2449C8.13069 14.9807 8.02615 14.7273 7.8399 14.5399C7.74694 14.4462 7.63633 14.3718 7.51448 14.321C7.39262 14.2702 7.26191 14.2441 7.1299 14.2441C6.99789 14.2441 6.86718 14.2702 6.74532 14.321C6.62346 14.3718 6.51286 14.4462 6.4199 14.5399ZM6.4199 6.04989C6.23365 6.23726 6.12911 6.49071 6.12911 6.75489C6.12911 7.01908 6.23365 7.27253 6.4199 7.45989C6.51286 7.55362 6.62346 7.62802 6.74532 7.67879C6.86718 7.72955 6.99789 7.75569 7.1299 7.75569C7.26191 7.75569 7.39262 7.72955 7.51448 7.67879C7.63633 7.62802 7.74694 7.55362 7.8399 7.45989C8.02615 7.27253 8.13069 7.01908 8.13069 6.75489C8.13069 6.49071 8.02615 6.23726 7.8399 6.04989C7.74694 5.95617 7.63633 5.88177 7.51448 5.831C7.39262 5.78023 7.26191 5.7541 7.1299 5.7541C6.99789 5.7541 6.86718 5.78023 6.74532 5.831C6.62346 5.88177 6.51286 5.95617 6.4199 6.04989ZM11.3699 16.0499C11.1721 16.0499 10.9788 16.1085 10.8143 16.2184C10.6499 16.3283 10.5217 16.4845 10.446 16.6672C10.3703 16.8499 10.3505 17.051 10.3891 17.245C10.4277 17.439 10.5229 17.6171 10.6628 17.757C10.8026 17.8969 10.9808 17.9921 11.1748 18.0307C11.3688 18.0693 11.5699 18.0495 11.7526 17.9738C11.9353 17.8981 12.0915 17.7699 12.2014 17.6055C12.3112 17.441 12.3699 17.2477 12.3699 17.0499C12.3767 16.9144 12.3558 16.779 12.3086 16.6518C12.2614 16.5247 12.1888 16.4085 12.0953 16.3102C12.0017 16.212 11.8892 16.1339 11.7645 16.0805C11.6398 16.0272 11.5055 15.9997 11.3699 15.9999V16.0499ZM5.3699 10.0499C5.17212 10.0499 4.97878 10.1085 4.81433 10.2184C4.64988 10.3283 4.52171 10.4845 4.44602 10.6672C4.37033 10.8499 4.35053 11.051 4.38911 11.245C4.4277 11.439 4.52294 11.6171 4.66279 11.757C4.80264 11.8969 4.98083 11.9921 5.17481 12.0307C5.36879 12.0693 5.56986 12.0495 5.75258 11.9738C5.93531 11.8981 6.09149 11.7699 6.20137 11.6055C6.31125 11.441 6.3699 11.2477 6.3699 11.0499C6.37668 10.9144 6.35583 10.779 6.30862 10.6518C6.26141 10.5247 6.18883 10.4085 6.09529 10.3102C6.00174 10.212 5.8892 10.1339 5.76449 10.0805C5.63979 10.0272 5.50554 9.99972 5.3699 9.99989V10.0499ZM11.3699 4.04989C11.1721 4.04989 10.9788 4.10854 10.8143 4.21842C10.6499 4.32831 10.5217 4.48449 10.446 4.66721C10.3703 4.84994 10.3505 5.051 10.3891 5.24499C10.4277 5.43897 10.5229 5.61715 10.6628 5.757C10.8026 5.89685 10.9808 5.99209 11.1748 6.03068C11.3688 6.06926 11.5699 6.04946 11.7526 5.97377C11.9353 5.89809 12.0915 5.76991 12.2014 5.60546C12.3112 5.44102 12.3699 5.24768 12.3699 5.04989C12.3767 4.91443 12.3558 4.779 12.3086 4.65184C12.2614 4.52468 12.1888 4.40846 12.0953 4.31024C12.0017 4.21202 11.8892 4.13385 11.7645 4.0805C11.6398 4.02715 11.5055 3.99972 11.3699 3.99989V4.04989ZM14.9099 6.09989C14.7695 6.23951 14.6736 6.41768 14.6346 6.61182C14.5955 6.80597 14.6149 7.00734 14.6905 7.19041C14.766 7.37348 14.8941 7.53001 15.0587 7.64016C15.2233 7.7503 15.4169 7.8091 15.6149 7.8091C15.8129 7.8091 16.0065 7.7503 16.1711 7.64016C16.3357 7.53001 16.4638 7.37348 16.5393 7.19041C16.6149 7.00734 16.6343 6.80597 16.5952 6.61182C16.5562 6.41768 16.4603 6.23951 16.3199 6.09989C16.1392 5.90685 15.8895 5.79321 15.6252 5.78384C15.361 5.77447 15.1038 5.87013 14.9099 6.04989V6.09989ZM21.2099 6.09989C20.2956 4.27219 18.8903 2.73531 17.1515 1.6616C15.4127 0.587877 13.4091 0.0197769 11.3655 0.0209981C9.32189 0.0222193 7.31902 0.592714 5.58148 1.66851C3.84395 2.7443 2.44045 4.28286 1.52838 6.11166C0.616305 7.94045 0.231718 9.98717 0.417743 12.0223C0.603768 14.0574 1.35305 16.0005 2.58157 17.6336C3.81008 19.2668 5.46926 20.5254 7.37304 21.2683C9.27682 22.0113 11.3499 22.2092 13.3599 21.8399C13.8653 21.7448 14.3468 21.5499 14.776 21.2666C15.2053 20.9833 15.5737 20.6172 15.8599 20.1899C16.1682 19.7253 16.381 19.2039 16.4857 18.6562C16.5905 18.1086 16.5851 17.5455 16.4699 16.9999C16.4069 16.6702 16.3735 16.3355 16.3699 15.9999C16.3743 15.0309 16.6602 14.084 17.1928 13.2744C17.7254 12.4648 18.4817 11.8275 19.3699 11.4399C19.8488 11.2255 20.2786 10.9152 20.6329 10.5282C20.9872 10.1413 21.2585 9.68577 21.4299 9.18989C21.6033 8.68318 21.6732 8.1468 21.6354 7.61258C21.5976 7.07835 21.4529 6.55715 21.2099 6.07989V6.09989ZM19.5099 8.53989C19.4246 8.77921 19.2921 8.99898 19.1203 9.18621C18.9486 9.37343 18.741 9.5243 18.5099 9.62989C17.2799 10.1805 16.2349 11.0744 15.5006 12.2044C14.7662 13.3343 14.3736 14.6523 14.3699 15.9999C14.3714 16.47 14.4183 16.9388 14.5099 17.3999C14.571 17.6817 14.575 17.9729 14.5218 18.2562C14.4685 18.5396 14.3591 18.8095 14.1999 19.0499C14.0652 19.2603 13.888 19.4402 13.6796 19.578C13.4712 19.7157 13.2362 19.8084 12.9899 19.8499C12.4558 19.9503 11.9134 20.0005 11.3699 19.9999C10.1641 20.0005 8.97041 19.7587 7.85982 19.289C6.74923 18.8193 5.74435 18.1313 4.90486 17.2656C4.06537 16.4 3.40838 15.3745 2.97291 14.2501C2.53745 13.1256 2.33238 11.9251 2.3699 10.7199C2.44751 8.47269 3.3589 6.33485 4.92653 4.72286C6.49415 3.11086 8.60573 2.14018 10.8499 1.99989H11.3599C13.0357 2.00031 14.678 2.46858 16.102 3.35196C17.526 4.23534 18.6751 5.49874 19.4199 6.99989C19.6491 7.47488 19.6815 8.02118 19.5099 8.51989V8.53989ZM11.3699 9.99989C11.1721 9.99989 10.9788 10.0585 10.8143 10.1684C10.6499 10.2783 10.5217 10.4345 10.446 10.6172C10.3703 10.7999 10.3505 11.001 10.3891 11.195C10.4277 11.389 10.5229 11.5671 10.6628 11.707C10.8026 11.8469 10.9808 11.9421 11.1748 11.9807C11.3688 12.0193 11.5699 11.9995 11.7526 11.9238C11.9353 11.8481 12.0915 11.7199 12.2014 11.5555C12.3112 11.391 12.3699 11.1977 12.3699 10.9999C12.3699 10.7347 12.2645 10.4803 12.077 10.2928C11.8895 10.1053 11.6351 9.99989 11.3699 9.99989Z" fill="currentColor"/>
      </svg>
      <div class="font-color-modal-background position-fixed top-0 start-0 bottom-0 end-0 overflow-hidden"
        style="display: none; z-index: 1000; backdrop-filter: blur(2px);"
      >
      <div
        class="font-color-modal-popup card position-absolute"
      >
        <div class="card-body">
          <div class="card-text text-left text-body">
            ${this.colorSection("Theme colors", colorSamples)}
            <div class="font-color-recent text-left">
            </div>
            <div class="color-section">
              <input type="color" class="font-color-input w-100">
            </div>        
          </div>
        </div>
      </div>
    </div>      
    `;
    this.currentColor = "";
    this.on(this.button, "click", this.showPopup.bind(this));
    this.on(
      this.button.querySelector(".font-color-modal-background"),
      "click",
      this.canHidePopup.bind(this)
    );
    this.on(
      this.base.origElements,
      "click",
      this.getCurrentFontColor.bind(this)
    );
    this.on(
      this.button.querySelector(".font-color-input"),
      "change",
      (event) => {
        event.stopPropagation();
        this.applyColor(event.target.value);
        this.addToRecent(event.target.value);
        this.hidePopup();
      }
    );
  },
  colorSection(label, samples) {
    if (!samples.length) return "";
    return [
      `<label classs="color-section-label">${label}</label>`,
      '<div class="color-section">',
      ...samples.map(
        (color) =>
          `<div class="color-box" style="background-color: ${color}"></div> `
      ),
      "</div>",
    ].join("\n");
  },
  subscribeBoxes() {
    const boxes = this.button.querySelectorAll(".color-box");
    Array.from(boxes).forEach((element) => {
      this.on(element, "click", (event) => {
        event.stopPropagation();
        this.applyColor(element.style.backgroundColor);
        this.addToRecent(element.style.backgroundColor);
        this.hidePopup();
      });
    });
  },
  getButton() {
    return this.button;
  },
  rgbColor2Hex(color) {
    if(color[0] === '#') {
      return color
    }
    const [red, green, blue] = color
      .split("")
      .filter((e) => e === "," || (e >= "0" && e <= "9"))
      .join("")
      .split(",");
    function toHex(c) {
      const hex = parseInt(c, 10).toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    }
    return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
  },
  getCurrentFontColor() {
    const selection = this.base.getSelectedParentElement();
    this.currentColor = this.rgbColor2Hex(window.getComputedStyle(selection).color)
  },
  showPopup(event) {
    event.stopPropagation();
    const { left, bottom } = this.button.getBoundingClientRect();
    this.button.querySelector(".font-color-modal-background").style.display =
      "";
    this.button.querySelector(
      ".font-color-modal-popup"
    ).style.top = `${bottom}px`;
    this.button.querySelector(
      ".font-color-modal-popup"
    ).style.left = `${left}px`;
    this.button.querySelector(".font-color-input").value = this.currentColor;
    this.button.querySelector(".font-color-recent").innerHTML =
      this.colorSection("Last used colors", this.getRecentColors());
    this.subscribeBoxes();
    document.body.style.overflow = "hidden";
  },
  canHidePopup(event) {
    const popup = this.button.querySelector(".font-color-modal-popup");
    if (!popup.contains(event.target)) {
      event.stopPropagation();
      this.hidePopup(event);
    }
  },
  hidePopup() {
    this.button.querySelector(".font-color-modal-background").style.display =
      "none";
    document.body.style.overflow = "auto";
  },
  applyColor(color) {
    const selectionState = this.base.exportSelection();
    if (selectionState.start === selectionState.end) {
      const selection = this.base.getSelectedParentElement();
      this.base.selectElement(selection);
      selection.style.color = color;
    } else {
      const fontName = "imaginary";
      this.document.execCommand("fontName", false, fontName);
      const fontElement = this.document.querySelector('font[face="imaginary"]');
      let parent = fontElement;

      while (
        parent.innerText === parent.parentElement.innerText &&
        parent.parentElement !== this.base.origElements
      ) {
        parent = parent.parentElement;
      }

      if (fontElement === parent) {
        const spanElement = this.document.createElement("span");
        spanElement.innerText = fontElement.innerText;
        spanElement.style.color = color;
        parent.parentNode.replaceChild(spanElement, fontElement);
      } else {
        this.document.execCommand("undo", false);
        parent.style.color = color;
      }
      this.base.importSelection(selectionState, true);
    }
    this.base.checkContentChanged();
  },
  getRecentColors() {
    try {
      return JSON.parse(localStorage["recent-colors"]) || [];
    } catch {
      return [];
    }
  },
  addToRecent(value) {
    const storedColors = this.getRecentColors();
    const color = this.rgbColor2Hex(value)
    const recentColors = [
      ...storedColors.filter((e) => e !== color),
      color,
    ].slice(-8);
    localStorage["recent-colors"] = JSON.stringify(recentColors);
  },
});

export default FontColorButton;
